export const ROUNDTRIP = 'RT';
export const ONEWAY = 'OW';
export const TRIP_TYPES = {
  ROUND_TRIP: 'ROUND_TRIP',
  ONE_WAY: 'ONE_WAY',
  MULTI_STOP: 'MULTI_STOP',
  DOMESTIC_ROUND_TRIP: 'DOMESTIC_ROUND_TRIP',
  DOMESTIC_ONE_WAY: 'DOMESTIC_ONE_WAY',
};
